export const integrationsDirectCdiJobSyncStatusSummary = "/integrations/direct/cdi/job_sync_status_summary";
